module.exports = __webpack_public_path__ + "img/loca-fm.1150f588.png";